import { SmlsInputText } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/RedoRegisterTangie/context/MemberDataContext';
import React, { useEffect, useState } from 'react';

export function AddressStateInput() {
  const { handler, formData, setFormEdit } = useMemberData();
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation('user_data_confirmation');
  const { t: t2 } = useTranslation('redo-register-v2');

  useEffect(() => {
    setValue(formData.state);
  }, [handler]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormEdit();
  };

  return (
    <SmlsInputText
      textLabel={formData.isForeign ? t('state_region_province') : t2('labels.addressState')}
      disabled={!formData.isForeign}
      onChange={handleChange}
      value={value}
      data-testid="first-access-address-state-input"
    />
  );
}
